import API from "./api";

export const createOrder = (plan) =>
  API.post("/api/payment/create-order", { plan });

export const verifyPayment = (data) =>
  API.post("/api/payment/verify", data);

export const getPaymentStatus = () =>
  API.get("/api/payment/status");

/**
 * Opens the Razorpay checkout modal and returns a promise that resolves
 * with the payment response on success or rejects on dismissal / failure.
 */
export function openRazorpayCheckout({ order, keyId, user }) {
  return new Promise((resolve, reject) => {
    const key = keyId || process.env.REACT_APP_RAZORPAY_KEY_ID;
    if (!key) {
      reject(new Error("Razorpay key not configured"));
      return;
    }

    const options = {
      key,
      amount: order.amount,
      currency: order.currency || "INR",
      name: "Referral Copilot",
      description: order.description || "Plan Upgrade",
      order_id: order.id,
      prefill: {
        name: user?.displayName || "",
        email: user?.email || "",
      },
      theme: { color: "#2563eb" },
      handler: (response) => resolve(response),
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
        escape: true,
        confirm_close: true,
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (resp) =>
      reject(new Error(resp.error?.description || "Payment failed"))
    );
    rzp.open();
  });
}
